import React, { useState } from 'react'
import './styles.scss'

import Shield from '../../assets/svgs/VerifiedShield'

import IconBox from '../IconBox'
import { currencyFloatToString } from '../../helpers/currency'
import { PropertyValues, PropertyTetantPays } from 'types/propertyAnnouncement'

interface Props {
  bondValue: number
  insuredReceivedValue: number
  insuredDisplayValue: number
  values: PropertyValues
  tenantPays: PropertyTetantPays
}

const BondText = () => (
  <>
    <span style={{ fontSize: '0.8em' }}>Caução de entrada de até</span>
  </>
)

const WarrantySelector = (props: Props) => {
  const [expanded, setExpanded] = useState(false)
  const texts = [
    { nonInsured: 'Recibo Manual', insured: 'Recibo automático' },
    { nonInsured: 'Sem Boleto', insured: 'Com boleto' },
    { nonInsured: 'até 3 meses de depósito*', insured: '15% de Seguro pagos pelo morador' },
    { nonInsured: 'Sem cobertura jurídica', insured: 'Com cobertura Jurídica*' },
    { nonInsured: 'A cobrança é feita pelo dono', insured: 'A seguradora cobra em caso de atraso' },
    {
      nonInsured: 'Sem taxas \n Sem comissão \n Sem Surpresas',
      insured: 'Sem taxas \n Sem comissão \n Sem Surpresas',
    },
    {
      nonInsured: 'Contrato com assinatura eletrônica gratuita',
      insured: 'Contrato com assinatura eletrônica gratuita',
    },
    {
      nonInsured: 'Gerenciamento automático gratuito',
      insured: 'Gerenciamento automático gratuito',
    },
  ]

  const generateWarrantiesInfo = () => {
    const info = texts.map((text) => (
      <div className='info-row'>
        <div className='not-insured'>
          <p>{text.nonInsured}</p>
        </div>
        <div className='insured'>
          <p>{text.insured}</p>
        </div>
      </div>
    ))

    return info
  }
  const expanderText = expanded ? 'FECHAR COMPARATIVO' : 'CONTINUAR COMPARANDO'
  return (
    <div className='selector-container'>
      <div className='conditions'>
        <div className='left'>
          <IconBox
            id='a'
            label='03 meses'
            Icons={[{ id: 'BondText', Icon: BondText }]}
            key={'BondText'}
            textStyle={{ fontSize: '1em', transform: 'translateY(-10px)' }}
            staticStyle
          />
        </div>
        <div className='right'>
          <IconBox
            id='b'
            label='Não precisa de fiador'
            Icons={[{ id: 'verifiedShield', Icon: Shield }]}
            key={'verified Icon'}
            textStyle={{ fontSize: '1em', transform: 'translateY(-10px)' }}
            staticStyle
          />
        </div>
      </div>
      <div className='values'>
        <div className='rent horizontal-divider'>
          <div className='announced-values horizontal-divider'>
            <div className='centralizer'>
              <p className='title'>Será cobrado no alugel:</p>
            </div>
            <div className='divided-values'>
              <div className='left-row'>
                <span className='money'>{currencyFloatToString(props.insuredReceivedValue)}</span>
              </div>
              <div className='value-separator' />
              <div className='right-row'>
                <span className='money'>{currencyFloatToString(props.insuredDisplayValue)}</span>
              </div>
            </div>
            <div></div>
          </div>
          <div className='received-values horizontal-divider'>
            <div className='centralizer'>
              <p className='title'>Entra na sua conta bancária</p>
            </div>
            <div className='divided-values'>
              <div className='left-row'>
                <span className='money'>{currencyFloatToString(props.bondValue)}</span>
                <div className='centralizer column'>
                  <p className='text'>
                    Sem garantia de recebimento, sem cobertura jurídica e outros
                  </p>
                </div>
              </div>

              <div className='value-separator elongated' />

              <div className='right-row'>
                <span className='money'>{currencyFloatToString(props.bondValue)}</span>
                <div className='centralizer column'>
                  <p className='text'>
                    30 meses garantidos de aluguel, condomínio, IPTU e outros *
                  </p>
                  <p className='text small'>A diferença é utilizada para pagar o Seguro Fiança</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='other-values horizontal-divider'>
          <div className='centralizer column margin-bottom'>
            <p className='title'>Condomínio</p>
            <span className='value bold'>{`${currencyFloatToString(
              props.values.condo,
            )} (Aproximado)`}</span>
            {!props.tenantPays.condo && (
              <span className='owner-responsability'>Responsabilidade do Dono do imóvel</span>
            )}
          </div>
        </div>
        <div className='other-values horizontal-divider'>
          <div className='centralizer column margin-bottom'>
            <p className='title'>IPTU</p>
            <span className='value bold'>
              {`${currencyFloatToString(props.values.iptu)} (Aproximado)`}
            </span>
            {!props.tenantPays.iptu && (
              <span className='owner-responsability'>Responsabilidade do Dono do imóvel</span>
            )}
          </div>
        </div>
        <div className='other-values horizontal-divider margin-bottom'>
          <div className='centralizer column'>
            <p className='title'>Others</p>
            <span className='value bold'>{`${currencyFloatToString(
              props.values.other,
            )} (Aproximado)`}</span>
            {!props.tenantPays.other && (
              <span className='owner-responsability'>Responsabilidade do Dono do imóvel</span>
            )}
          </div>
        </div>
      </div>
      {expanded && (
        <div className='warranties-info centralizer column'>{generateWarrantiesInfo()}</div>
      )}

      <div style={{ marginTop: 50 }}>
        <div onClick={() => setExpanded(!expanded)} className='expander'>
          <span className='expander-text'>{expanderText}</span>
        </div>
      </div>
    </div>
  )
}

export default WarrantySelector
